import React from 'react';

export const SessionContext = React.createContext({
    user: {},
    setUser: (user) => { }
});

export const ThemeProvider = SessionContext.Provider;
export const ThemeConsumer = SessionContext.Consumer;